import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import MenuItem from '@mui/material/MenuItem';
import { Colors } from '../../../../constants';

export const NavLinkOverride = styled(NavLink)`
  color: black;
  text-decoration: none;
  font-size: 14px;
`;

export const ExternalLink = styled.a`
  color: black;
  text-decoration: none;
  font-size: 14px;
`;

export const MenuLabel = styled(MenuItem)`
  color: ${Colors.BLACK_80} !important;
`;
